import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { LangLoaderUtil } from "../../util/lang/LangLoaderUtil";
/**
 * CurrencyLoader.ts
 */
export class ErrorCodeDisplayData {
}
export class ErrorCodeDialogData {
    constructor() {
        this.fatal = false;
    }
}
/*
"26":{
    "name":"RESPONSE_GAME_ACCESS_DENIED",
    "fatal":true,
    "display":{
        "title" : "CommonLang.ERROR_TITLE",
        "message" : "CommonLang.ERROR_MESSAGE",
        "confirmAction" : "nonRecoverableErrorComplete"
    }
}
*/
export class ErrorCodesHandler {
    constructor() {
        this.errorCodes = new Map();
        if (ErrorCodesHandler.instance) {
            throw new Error("ErrorCodesHandler Singleton Already Initialised");
        }
        ErrorCodesHandler.instance = this;
    }
    getErrorCodes() {
        return this.errorCodes;
    }
    static getInstance() {
        if (ErrorCodesHandler.instance === null) {
            ErrorCodesHandler.instance = new ErrorCodesHandler();
        }
        return ErrorCodesHandler.instance;
    }
    load(_callback) {
        let url = LangLoaderUtil.getLangOrigin();
        let cache = Date.now();
        url += "/rgs/lang/errorCodes/errorCodes.json?cache=" + cache;
        let request = new HttpRequest(RequestConstants.GET, url);
        request.setContentType(RequestConstants.APPLICATION_JSON);
        request.setResponseType(RequestConstants.TEXT);
        request.onComplete(() => {
            let errorCodes = request.getJSON();
            if (errorCodes) {
                for (let key in errorCodes) {
                    let erroCodeNumber = parseInt(key);
                    let errorCodeData = errorCodes[key];
                    this.errorCodes.set(erroCodeNumber, errorCodeData);
                    //console.log(erroCodeNumber, errorCodeData);
                }
            }
            if (_callback) {
                _callback();
            }
        }, this);
        request.onError(() => {
            console.error("Failed to get errorCodes from " + url);
            if (_callback) {
                _callback();
            }
        }, this);
        request.send();
    }
}
ErrorCodesHandler.instance = null;
//# sourceMappingURL=ErrorCodesHandler.js.map